import { rem } from 'utils/fonts';

const cofo = '"cofo", sans-serif';
const antique = '"antique", sans-serif';

const fontSizes = {
  xs: rem(12),
  sm: rem(13),
  md: rem(14),
  mdMax: rem(15),
  lgMin: rem(16),
  lg: rem(18),
  lgMax: rem(19),
  xl: rem(20),
  xlMax: rem(22),
  '2xl': rem(24),
  '3xl': rem(28),
  '4xl': rem(32),
  '5xl': rem(42),
};

export { cofo, antique, fontSizes };

export default cofo;
